module.exports = __webpack_public_path__ + "static/img02-e52323ae7a961aa82f0badd86d0af0d2.jpg";